import { Component } from 'react';
import DineInCustomerInfo from './containers/DineInCustomerInfo/DineInCustomerInfo';
import ScrollableBlock from 'src/view/containers/ScrollableBlock/ScrollableBlock';

export default class OrderDineIn extends Component<{}, {}> {
  render() {
    return (
      <ScrollableBlock>
        <div className="d-flex flex-row mt-3">
          <DineInCustomerInfo />
        </div>
      </ScrollableBlock>
    );
  }
}
